export default __webpack_public_path__ + "WHS-Logo_Standard_Color.2625e61a.png";